import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center" data-testid="not-found-page">
      <div className="text-xs uppercase tracking-[0.28em] text-red-500 font-mono-brand mb-4">404</div>
      <h1 className="font-display text-6xl md:text-7xl font-black text-white tracking-tighter">
        Off Route
      </h1>
      <p className="mt-4 text-slate-400 max-w-md">
        This page took a wrong turn. Let's get you back on the highway.
      </p>
      <Link to="/" className="mt-8">
        <Button className="bg-red-600 hover:bg-red-700 rounded-full">
          <ArrowLeft className="w-4 h-4 mr-2" /> Back home
        </Button>
      </Link>
    </div>
  );
}
